import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cancel\"><path d=\"M108.813087 474.000084L104.999958 477.813213 101.186829 474.000084 100 475.186913 103.813129 479.000042 100 482.813171 101.186829 484 104.999958 480.186871 108.813087 484 109.999916 482.813171 106.186787 479.000042 109.999916 475.186913z\" transform=\"translate(-100 -474)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/cancel.svg
// module id = 96
// module chunks = 0